import React from "react";
import { connect } from "dva";
import { component_tool, framework_tool } from "@/tool";
import { modelUtils } from '@/utils'

const { WizTreeSelect } = component_tool;
const { WizContainer } = framework_tool;

class WizTreeSelectPlus extends WizContainer {
  componentName = "WizTreeSelectPlus";

  constructor(props) {
    super(props);
    this.state = {
      list: []
    };
  }

  propsAndStateOnChange = {
    treeData: this._treeData.bind(this)
  };

  _treeData(nextProps, nextState) {
    if (nextProps.treeData.success) {
      nextState.list = nextProps.treeData.data
      return true
    }
    return false;
  }

  _componentDidMount() {
    this.doAction({
      path: `organizationNodeCategoryx/getTypeNodeList`,
      payload: {
        key: `organizationNodeCategoryx@getTypeNodeList`,
        apiParams: {},
      }
    });
  }

  handleChange = value => {
    const { onChange } = this.props
    onChange && onChange(value)
  }

  _render() {
    const { value } = this.props;
    const { list } = this.state;
    const props = {
      treeData: list,
      defaultValue: value,
      onChange: this.handleChange,
      allowClear: true,
      style: { width: '100%' }
    }

    return <WizTreeSelect key={'WizTreeSelectPlus' + (value || '')} {...props} />
  }
}

const mapStateToProps = (state, ownProps) => {
  const { organizationNodeCategoryx } = state;
  const treeData = modelUtils.getModelEntity(organizationNodeCategoryx, "organizationNodeCategoryx@getTypeNodeList");
  const load = modelUtils.getLoadingState(state, "organizationNodeCategoryx");

  return {
    treeData,
    ...load,
  };
};

export default connect(mapStateToProps)(WizTreeSelectPlus);
